var map = {
	"./developer_gisselles_adventure/capsula_principal.png": 1740,
	"./developer_gisselles_adventure/clausula_vertical.png": 5353,
	"./developer_gisselles_adventure/epic_store.png": 1413,
	"./developer_gisselles_adventure/googleplay_store.png": 1285,
	"./developer_gisselles_adventure/microsoft_store.png": 2532,
	"./developer_gisselles_adventure/steam_store.png": 1712,
	"./developer_gisselles_adventure/xbox_store.png": 4613,
	"./web_developer_educ/educ_logo.png": 8573,
	"./web_developer_educ/educ_logo_page.png": 4671,
	"./web_developer_educ/interface_educ.png": 7371,
	"./web_developer_educ/interface_educ2.png": 7697,
	"./web_developer_educ/interface_educ3.png": 9832,
	"./web_developer_educ/universidad_de_colima.png": 6082
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4826;